import React from 'react';
import "./styles.css";
/**
 * @function LeftColumnContainer 
 * @param {React.Component} children - React components or content that's being wrapped by the left column container.
 * @returns {React.Component}
 * @example
 * <LeftColumnContainer>
 *  <h1>Content</h1>
 * </LeftColumnContainer>
 */
export default function LeftColumnContainer(props) {
  return (
    <>
    <div className="left-column-container column flex-width flex-container flex-vertical">
      {props.children}
    </div>
    <div className="column-divider" />
    </>
  );
}